module.exports = __webpack_public_path__ + "img/114.45d134a5.jpg";